import React, { useEffect, useState, } from 'react';
import { Box, Button, Typography, } from '@mui/material';
import '../../mentorComponents/labPractice/LabPractice.css';

import MakerModuleModal from './MakerModuleModal';
import MakerModuleTable from './MakerModuleTable';
import { getAllTopicsData } from '../../../services/adminServices/ModuleServices';
import { toast } from 'react-toastify';

const MakerModule = () => {
  const [modalOpen, setModalOpen] = useState({ userForm: false });
  const [allTopics, setAllTopics] = useState()
  const [editRowData, setEditRowData] = useState(null);

  const handleModalToggle = (modalName, data = null) => {
    setModalOpen((prev) => ({ ...prev, [modalName]: !prev[modalName] }));
    if (!data) {
      setEditRowData(null);
    } else {
      setEditRowData(data);
    }
  };
  const handleEditClick = (data) => {
    handleModalToggle('userForm', data);
  };

  async function getAllTopics() {
    try {
      const allTopics = await getAllTopicsData();
      setAllTopics(allTopics?.data?.data);
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error?.error);
      setAllTopics([]);
    }
  };

  useEffect(() => {
    getAllTopics();
  }, []);


  return (
    <Box className="dashboard-container">
      <Box className="DailyPractice-header">
        <Typography className="dashboard-header-title"></Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleModalToggle('userForm')}
          className="dashboard-header-button"
        >
          CREATE MODULE
        </Button>
        <MakerModuleModal open={modalOpen.userForm} onClose={() => handleModalToggle('userForm')}
          rowData={editRowData} modules={allTopics} fetchModules={getAllTopics} />
      </Box>

      <Box className="dashboard-box-container">
        <MakerModuleTable rows={allTopics} onEditClick={handleEditClick} getAllTopics={getAllTopics} />
      </Box>
    </Box>
  );
};

export default MakerModule;